// src/components/products/ProductsTab.jsx
import React from "react";
import { freeProducts, premiumProducts } from "../../data/products";

export default function ProductsTab() {
  return (
    <div className="product-sections">
      <Card
        title={`Free Products (${freeProducts.length})`}
        subtitle="Get started without paying a cent"
      >
        <div className="product-grid">
          {freeProducts.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </Card>

      <Card
        title={`Premium Products (${premiumProducts.length})`}
        subtitle="Unlock advanced features and scale"
      >
        <div className="product-grid">
          {premiumProducts.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </Card>
    </div>
  );
}

/* --- Local UI bits for this tab --- */
function Card({ title, subtitle, children }) {
  return (
    <section className="card">
      <header className="card-head">
        <h3>{title}</h3>
        {subtitle && <p className="muted small">{subtitle}</p>}
      </header>
      <div className="card-body">{children}</div>
    </section>
  );
}

function ProductCard({ product }) {
  const { id, name, blurb, price, rating, features, tier, url } = product;
  const stars = Math.round(rating);

  return (
    <article className="product">
      <header className="product-head">
        <div className="product-title">
          <h4>{name}</h4>
          <span className="sku">{id}</span>
        </div>
        <div className="rating" aria-label={`Rating ${rating} out of 5`}>
          <span className={`tier ${tier === "Free" ? "free" : "premium"}`}>
            {tier}
          </span>
          {Array.from({ length: 5 }).map((_, i) => (
            <span key={i} className={i < stars ? "full" : "empty"}>
              {i < stars ? "★" : "☆"}
            </span>
          ))}
          <span className="muted small">{rating.toFixed(1)}</span>
        </div>
      </header>

      <p className="blurb">{blurb}</p>

      <ul className="features">
        {features.map((f) => (
          <li key={f}>{f}</li>
        ))}
      </ul>

      <div className="product-cta">
        <span className="price">{price === 0 ? "Free" : `$${price}/mo`}</span>

        {price === 0 && url ? (
          <a href={url} target="_blank" rel="noopener noreferrer" className="btn">
            Get Started
          </a>
        ) : price === 0 ? (
          <button className="btn" onClick={() => alert(`Started with ${name}`)}>
            Get Started
          </button>
        ) : url ? (
          <a href={url} target="_blank" rel="noopener noreferrer" className="btn">
            Visit Product
          </a>
        ) : (
          <button
            className="btn"
            onClick={() => alert(`Added ${name} to cart`)}
          >
            Add to Cart
          </button>
        )}
      </div>
    </article>
  );
}